import React from 'react';
import PropTypes from 'prop-types';
import DOMPurify from 'dompurify';
import withInit from 'WithInit';

const Subheading = props => (
  <div className="controls subheading">
    <h4
      dangerouslySetInnerHTML={{ __html: `${DOMPurify.sanitize(props.label)}` }}
    />
  </div>
);

Subheading.propTypes = {
  label: PropTypes.string.isRequired,
};

export default withInit(Subheading);



// WEBPACK FOOTER //
// ./src-react/StaticBuilder/Subheading.jsx